import { render, staticRenderFns } from "./customService.vue?vue&type=template&id=3a350dda&scoped=true"
import script from "./customService.vue?vue&type=script&lang=js"
export * from "./customService.vue?vue&type=script&lang=js"
import style0 from "./customService.vue?vue&type=style&index=0&id=3a350dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a350dda",
  null
  
)

export default component.exports